import React from 'react';
import { string } from 'prop-types';

import styles from './index.module.scss';

const SelectGroupLabel = ({ label = '' }) =>
    label ? (
        <div className={`${styles.groupLabel} p-l-16 p-r-16 p-t-8 p-b-4`}>
            <span className="tbody-7">{label}</span>
        </div>
    ) : null;

SelectGroupLabel.propTypes = {
    label: string
};

export default SelectGroupLabel;
